import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { getServiceBlocks } from '@/core/components/sites/site/service-blocks/serviceBlocksQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const serviceBlocksSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum(['id', 'shortTitle', 'roomCode', 'startDate', 'endDate', 'type'])
    .catch('startDate'),
  orderBy: z.enum(['asc', 'desc']).catch('asc'),
})
export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/service-blocks/'
)({
  validateSearch: (search) => serviceBlocksSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const serviceBlocks = queryClient.ensureQueryData(
      getServiceBlocks(siteId, auth.token!)
    )
    return {
      serviceBlocks,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
